import { helper } from '@ember/component/helper';

const SAFE_PROPERTY = /^[a-zA-Z-]+$/;
const DANGEROUS_VALUE = /[{};]|expression\s*\(/i;
const cssStyle = ([property, value]) => {
  if (!property || value == null) return '';
  if (!SAFE_PROPERTY.test(property)) return '';
  const strValue = String(value);
  if (DANGEROUS_VALUE.test(strValue)) return '';
  // Plain string, non htmlSafe: nel binding `style={{css-style ...}}` Ember
  // escapa da sé virgolette/angolari, chiudendo il breakout dall'attributo.
  return `${property}: ${strValue}`;
};
var cssStyle$1 = helper(cssStyle);

export { cssStyle, cssStyle$1 as default };
//# sourceMappingURL=css-style.js.map
